import { motion } from "framer-motion";
import { Building2, UsersRound, ClipboardCheck } from "lucide-react";

const STEPS = [
  {
    icon: Building2,
    title: "Tạo trung tâm",
    desc: "Đăng ký tài khoản quản trị, thiết lập thông tin trung tâm và cấu hình cơ bản.",
  },
  {
    icon: UsersRound,
    title: "Thêm lớp & học viên",
    desc: "Tạo danh sách lớp học, gán giáo viên phụ trách và nhập hồ sơ học viên vào hệ thống.",
  },
  {
    icon: ClipboardCheck,
    title: "Quản lý hàng ngày",
    desc: "Giáo viên điểm danh mỗi buổi, theo dõi tỷ lệ đi học và tổng hợp báo cáo lớp.",
  },
];

export function LandingSteps() {
  return (
    <section id="cach-dung" className="bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-12">
          <div className="text-xs font-medium uppercase tracking-wider text-blue-600">
            Cách dùng
          </div>
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight text-slate-900 dark:text-white font-display">
            Bắt đầu trong ba bước
          </h2>
          <p className="mt-3 text-base md:text-lg text-slate-600 dark:text-slate-400">
            Không cần cài đặt phức tạp. Mở trình duyệt là dùng được.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="relative rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 md:p-7 transition-colors hover:border-slate-300 dark:border-slate-700"
            >
              <div className="flex items-center gap-3">
                <div className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-blue-200 bg-blue-50 dark:bg-blue-500/10 text-sm font-semibold text-blue-700 dark:text-blue-300">
                  {i + 1}
                </div>
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-700 dark:text-slate-200">
                  <s.icon className="h-5 w-5" />
                </div>
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900 dark:text-white font-display">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
